AgrimarketControllers.controller('UnsubscribeNewsMarketInfoController', ['$scope', '$rootScope',
    function ($scope, $rootScope) {
        $scope.errorMessage = $rootScope.errorMessageUnsubscribeNewsMarketInfoByIdExt;
    }
]);
